import { render, staticRenderFns } from "./Signatue.vue?vue&type=template&id=4008ed64&scoped=true&"
import script from "./Signatue.vue?vue&type=script&lang=js&"
export * from "./Signatue.vue?vue&type=script&lang=js&"
import style0 from "./Signatue.vue?vue&type=style&index=0&id=4008ed64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4008ed64",
  null
  
)

export default component.exports